function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var genLayoutLightStyle = function genLayoutLightStyle(token) {
  var _$concat;

  var componentCls = token.componentCls,
      colorBgContainer = token.colorBgContainer,
      colorBgBody = token.colorBgBody,
      colorText = token.colorText;
  return _defineProperty({}, "".concat(componentCls, "-sider-light"), (_$concat = {
    background: colorBgContainer
  }, _defineProperty(_$concat, "".concat(componentCls, "-sider-trigger"), {
    color: colorText,
    background: colorBgContainer
  }), _defineProperty(_$concat, "".concat(componentCls, "-sider-zero-width-trigger"), {
    color: colorText,
    background: colorBgContainer,
    border: "1px solid ".concat(colorBgBody),
    borderInlineStart: 0
  }), _$concat));
};

export default genLayoutLightStyle;